export default __webpack_public_path__ + "static/media/abhinav_walia.03ed5466.png";